import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
interface SparklineChartProps {
  data: number[];
  color: string;
  width?: number | string;
  height?: number | string;
}
export function SparklineChart({
  data,
  color,
  width = '100%',
  height = 40
}: SparklineChartProps) {
  const chartData = data.map((val, index) => ({
    value: val,
    index
  }));
  return <div style={{
    width,
    height
  }} data-id="element-150">
      <ResponsiveContainer width="100%" height="100%" data-id="element-151">
        <LineChart data={chartData} data-id="element-152">
          <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={false} isAnimationActive={false} data-id="element-153" />
        </LineChart>
      </ResponsiveContainer>
    </div>;
}